/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const GlobeX = [
  ["path", { d: "m16 3 5 5" }],
  ["path", { d: "M2 12h20A10 10 0 1 1 12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 4-10" }],
  ["path", { d: "m21 3-5 5" }]
];

export { GlobeX as default };
//# sourceMappingURL=globe-x.js.map
